export const toastSelector = ({ photoErrorToast: { show, timeout } }) => ({ show, timeout });
